import * as THREE from 'three';
import Base from './base';
// import Stats from 'stats-js';

let app = new Base(document.querySelector('#output'));
app.resize();

// let stats = new Stats();
// document.body.appendChild(stats.dom);

window.addEventListener("resize", ( e ) =>
{
	app.resize();
})

function animate()
{
	requestAnimationFrame(animate);

	// stats.begin();

	// let dt = app.clock.getDelta();

	// et += dt;
	// if (et > 132)
	// et = 0;

	// let day = new Date();
	// let secs = day.getSeconds() + (60 * (day.getMinutes() + (60 * day.getHours())));
	// let s = secs / (60 * 60 * 24);
	// let k = 10.0;
	// let hlIntensity = Math.pow(4.0 * s * (1.0 - s), k);

	app.update();
	// stats.end();
}

animate();



// WEBPACK FOOTER //
// ./src/main.js